export default __webpack_public_path__ + "static/media/draw-users.2f892b13.png";